import { ENVIRONMENT } from '../../config';
import version from './version.json';

export const getAppVersion = () => {
  if (ENVIRONMENT !== 'production') {
    return version.stag;
  } else return version.prod;
};